import React from 'react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import { createStyles } from '@material-ui/core/styles';
import {
  Grid, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  InputAdornment, FormLabel
} from '@material-ui/core/';
import { AccessTime } from '@material-ui/icons/';
import Pagination from '@material-ui/lab/Pagination';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
// core components
import Table from '../../../components/Table/Table';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import CustomInput from '../../../components/CustomInput/CustomInput';
import Button from '../../../components/CustomButtons/Button';
import ImageDropZone from '../../../components/ImageDropZone';

const styles = createStyles({
  cardCategoryWhite: {
    '&,& a,& a:hover,& a:focus': {
      color: 'rgba(255,255,255,.62)',
      margin: '0',
      fontSize: '14px',
      marginTop: '0',
      marginBottom: '0'
    },
    '& a,& a:hover,& a:focus': {
      color: '#FFFFFF'
    }
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: 300,
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', sans-serif',
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: '#777',
      fontSize: '65%',
      fontWeight: 400,
      lineHeight: 1
    }
  }
});

function Issue(props: any) {
  const { classes } = props;
  const [open, setOpen] = React.useState(false);


  const handleClose = () => {
    setOpen(false);
  };



  const FormDialog = (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="create-work-order">New Issue</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Grid container justify="center" alignItems="center" spacing={2}>
            <Grid item xs={6}>
              <CustomInput
                id="asset-id"
                labelText="Asset ID"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-type"
                labelText="Asset Type"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-location"
                labelText="Asset Location"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-model"
                labelText="Asset Model"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                id="work-description"
                multiline
                rowsMax={4}
                labelText="Work description"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="work-schedule"
                labelText="Work schedule"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="repeating-schedule"
                labelText="Repeating schedule"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="estimate-completion-time"
                labelText="Estimated completion time"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormLabel>Priority </FormLabel>
              <ToggleButtonGroup
                size="small"
                exclusive
                aria-label="text alignment"
              >
                <ToggleButton value="None" aria-label="none">
                  None
                </ToggleButton>
                <ToggleButton value="low" aria-label="low">
                  Low
                </ToggleButton>
                <ToggleButton value="medium" aria-label="medium">
                  Medium
                </ToggleButton>
                <ToggleButton value="high" aria-label="high">
                  High
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="work-schedule"
                labelText="Work schedule"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="repeating-schedule"
                labelText="Repeating schedule"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="estimate-completion-time"
                labelText="Estimated completion time"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="work-schedule"
                labelText="Work schedule"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="assigned-to"
                labelText="Assigned To"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="assigned-team"
                labelText="Assigned Team"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <ImageDropZone />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="addtional"
                labelText="Add Additional"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Create
        </Button>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <Grid container>
              <Grid container item xs={8} alignContent="center">
                <h4 className={classes.cardTitleWhite}>Asset Financial Summary</h4>
              </Grid>
            </Grid>
          </CardHeader>
          <CardBody>
            <Table
              tableHeaderColor="primary"
              tableHead={['No.', 'Asset', 'Location', 'Asset Type', 'Asset Status', ' Risk', 'RUL']}
              tableData={[
               ]}
            />
          </CardBody>
        </Card>
        <div>
          <Pagination count={10} shape="rounded" />
        </div>
        {FormDialog}
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(Issue);
